export const ticketQuest = {
    id: 'the_ticket',
    titleKey: 'chapter_ticket',
    shortName: 'TICKET',
    date: '15.01.2026',
    status: 'completed',
    questMap: [
        {
            id: 'step_intel_center_1',
            label: {
                en: "Build Intelligence Center level 1",
                tr: "1. seviye İstihbarat Merkezi inşa et",
                ru: "Построить Разведцентр 1 уровня"
            },
            type: 'upgrade',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Build Intelligence Center level 1 in the Hideout.",
                    tr: "Sığınakta İstihbarat Merkezi 1. seviyeyi inşa et.",
                    ru: "Постройте Разведцентр 1 уровня в Убежище."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Upgrade the Intelligence Center to level 1 in your Hideout. This is required to continue the chapter.",
                            tr: "Sığınaktaki İstihbarat Merkezi'ni 1. seviyeye yükselt. Bu, bölüme devam edebilmek için gereklidir.",
                            ru: "Улучшите Разведцентр до 1 уровня в вашем Убежище. Это необходимо для продолжения главы."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_talk_kerman_1',
            label: {
                en: "Talk to Mr. Kerman",
                tr: "Bay Kerman ile konuş",
                ru: "Поговорить с господином Керманом"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Hideout / Intelligence Center", tr: "Sığınak / İstihbarat Merkezi", ru: "Убежище / Разведцентр" },
                objective: {
                    en: "Visit Mr. Kerman through the Intelligence Center laptop screen.",
                    tr: "İstihbarat Merkezi'ndeki dizüstü bilgisayar ekranı üzerinden Bay Kerman'ı ziyaret et.",
                    ru: "Свяжитесь с господином Керманом через экран ноутбука в Разведцентре."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open the Intelligence Center in your Hideout. Click on the laptop to talk to Mr. Kerman.",
                            tr: "Sığınağında İstihbarat Merkezi'ni aç. Bay Kerman ile konuşmak için dizüstü bilgisayara tıkla.",
                            ru: "Откройте Разведцентр в Убежище. Нажмите на ноутбук, чтобы поговорить с господином Керманом."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_wait_kerman',
            label: {
                en: "Wait for Mr. Kerman to reach out",
                tr: "Bay Kerman'ın iletişime geçmesini bekle",
                ru: "Дождаться связи от господина Кермана"
            },
            type: 'wait',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Wait 4-12 hours for Mr. Kerman to contact you.",
                    tr: "Bay Kerman'ın seninle iletişime geçmesi için 4-12 saat bekle.",
                    ru: "Подождите 4-12 часов, пока господин Керман свяжется с вами."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Wait 4-12 hours (real time). Mr. Kerman will contact you via in-game mail.",
                            tr: "Gerçek zamanlı olarak 4-12 saat bekle. Bay Kerman oyun içi posta yoluyla sana ulaşacak.",
                            ru: "Подождите 4-12 часов (реального времени). Господин Керман свяжется с вами через внутриигровую почту."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_talk_prapor',
            label: {
                en: "Talk to Prapor",
                tr: "Prapor ile konuş",
                ru: "Поговорить с Прапором"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Prapor and talk to him about Mr. Kerman.",
                    tr: "Prapor'u ziyaret et ve onunla Bay Kerman hakkında konuş.",
                    ru: "Посетите Прапора и поговорите с ним о господине Кермане."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open Traders menu. Select Prapor. Complete the dialogue about Mr. Kerman.",
                            tr: "Satıcılar menüsünü aç. Prapor'u seç. Bay Kerman hakkındaki diyalogu tamamla.",
                            ru: "Откройте меню торговцев. Выберите Прапора. Завершите диалог о господине Кермане."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_talk_kerman_2',
            label: {
                en: "Talk to Mr. Kerman again",
                tr: "Bay Kerman ile tekrar konuş",
                ru: "Поговорить с Керманом снова"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Hideout / Intelligence Center", tr: "Sığınak / İstihbarat Merkezi", ru: "Убежище / Разведцентр" },
                objective: {
                    en: "Return to Mr. Kerman via the Intelligence Center laptop.",
                    tr: "İstihbarat Merkezi dizüstü bilgisayarı üzerinden Bay Kerman'a geri dön.",
                    ru: "Вернитесь к господину Керману через ноутбук Разведцентра."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Talk to Mr. Kerman again through the Intelligence Center laptop.",
                            tr: "İstihbarat Merkezi dizüstü bilgisayarı aracılığıyla Bay Kerman ile tekrar konuş.",
                            ru: "Снова поговорите с господином Керманом через ноутбук Разведцентра."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_prapor_camp',
            label: {
                en: "Locate the camp of Prapor's people on Lighthouse",
                tr: "Deniz Feneri'nde Prapor'un adamlarının kampını bul",
                ru: "Найти лагерь людей Прапора на Маяке"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Find Prapor's camp in the rocky area on the west side of Lighthouse.",
                    tr: "Deniz Feneri (Lighthouse) haritasının batı tarafındaki kayalık alanda Prapor'un kampını bul.",
                    ru: "Найдите лагерь людей Прапора в скалистой местности на западной стороне Маяка."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Lighthouse. Navigate to the rocky area on the west side of the map.",
                            tr: "Deniz Feneri haritasına git. Haritanın batı tarafındaki kayalık bölgeye doğru ilerle.",
                            ru: "Отправляйтесь на Маяк. Двигайтесь к скалистой зоне на западной стороне карты."
                        },
                        images: ['/Story/Ticket/PraporCamp-Map.webp', '/Story/Ticket/PraporCamp-View.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_clues_prapor',
            label: {
                en: "Find clues about Prapor's people's intentions",
                tr: "Prapor'un adamlarının niyetleri hakkında ipuçları bul",
                ru: "Найти улики о намерениях людей Прапора"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Find the notes from Prapor's men at the camp.",
                    tr: "Kampta Prapor'un adamlarından kalan notları bul.",
                    ru: "Найдите записки от людей Прапора в лагере."
                },
                requiredItems: [
                    { en: "Note from Prapor's men", tr: "Prapor'un adamlarından not", ru: "Записка от людей Прапора" }
                ]
            },
            subTasks: [
                {
                    id: 'step_find_clues_item1',
                    label: {
                        en: "Clue 1: Ammo Boxes",
                        tr: "İpucu 1: Mühimmat Kutuları",
                        ru: "Улика 1: Ящики с патронами"
                    },
                    type: 'objective',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "Item 1: On a pile of wooden ammo boxes in the camp.",
                                    tr: "Eşya 1: Kampın içindeki ahşap mermi kutuları yığınının üzerinde.",
                                    ru: "Предмет 1: На груде деревянных ящиков с боеприпасами в лагере."
                                },
                                images: ['/Story/Ticket/Clue-AmmoBoxes.webp']
                            }
                        ]
                    }
                },
                {
                    id: 'step_find_clues_item2',
                    label: {
                        en: "Clue 2: Tent Bag",
                        tr: "İpucu 2: Çadır Çantası",
                        ru: "Улика 2: Сумка в палатке"
                    },
                    type: 'objective',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "Item 2: On a tent bag next to a guitar.",
                                    tr: "Eşya 2: Gitarın yanındaki çadır çantasının üzerinde.",
                                    ru: "Предмет 2: На сумке от палатки рядом с гитарой."
                                },
                                images: ['/Story/Ticket/Clue-Guitar.webp']
                            }
                        ]
                    }
                }
            ]
        },
        {
            id: 'step_talk_kerman_3',
            label: {
                en: "Talk to Mr. Kerman about findings",
                tr: "Bulgular hakkında Bay Kerman ile konuş",
                ru: "Рассказать Керману о находках"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Hideout / Intelligence Center", tr: "Sığınak / İstihbarat Merkezi", ru: "Убежище / Разведцентр" },
                objective: {
                    en: "Report back to Mr. Kerman with your findings.",
                    tr: "Bulgularınla ilgili Bay Kerman'a rapor ver.",
                    ru: "Доложите господину Керману о ваших находках."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Return to the Intelligence Center laptop and talk to Mr. Kerman.",
                            tr: "İstihbarat Merkezi dizüstü bilgisayarına geri dön ve Bay Kerman ile konuş.",
                            ru: "Вернитесь к ноутбуку Разведцентра и поговорите с господином Керманом."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_access_lightkeeper',
            label: {
                en: "Gain access to Lightkeeper",
                tr: "Işık Muhafızı'na erişim sağla",
                ru: "Получить доступ к Смотрителю"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Reach Lightkeeper on the 3rd floor of the lighthouse building.",
                    tr: "Deniz feneri binasının 3. katındaki Işık Muhafızı'na (Lightkeeper) ulaş.",
                    ru: "Доберитесь до Смотрителя на 3-м этаже здания маяка."
                },
                warning: {
                    en: "Requires encoded Digital secure DSP radio transmitter from the Network Provider questline. The bridge is guarded by Zryachiy and Claymores.",
                    tr: "Network Provider görev serisinden elde edilen kodlanmış Dijital DSP radyo vericisi gerektirir. Köprü, Zryachiy ve Claymore mayınları tarafından korunmaktadır.",
                    ru: "Требуется закодированный цифровой радиопередатчик DSP из цепочки квестов «Сетевой провайдер». Мост охраняется Зрячим и минами Клеймор."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Lighthouse. Cross the bridge with the encoded DSP transmitter.",
                            tr: "Deniz Feneri haritasına git. Kodlanmış DSP vericisi ile köprüyü geç.",
                            ru: "Отправляйтесь на Маяк. Перейдите мост с закодированным передатчиком DSP."
                        },
                        images: ['/Story/Ticket/Lightkeeper-Bridge.webp']
                    },
                    {
                        text: {
                            en: "Enter the locked area on the 3rd floor of the lighthouse building.",
                            tr: "Deniz feneri binasının 3. katındaki kilitli alana gir.",
                            ru: "Войдите в запертую зону на 3-м этаже здания маяка."
                        },
                        images: ['/Story/Ticket/Lightkeeper-Door.webp']
                    }
                ]
            }
        },
        {
            id: 'step_talk_lightkeeper_1',
            label: {
                en: "Talk to Lightkeeper",
                tr: "Işık Muhafızı ile konuş",
                ru: "Поговорить со Смотрителем"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Visit Lightkeeper and talk to him.",
                    tr: "Işık Muhafızı'nı ziyaret et ve onunla konuş.",
                    ru: "Посетите Смотрителя и поговорите с ним."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Enter Lightkeeper's area and complete the dialogue.",
                            tr: "Işık Muhafızı'nın alanına gir ve diyalogu tamamla.",
                            ru: "Войдите в зону Смотрителя и завершите диалог."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_stay_good_terms',
            label: {
                en: "Stay on good terms with Lightkeeper",
                tr: "Işık Muhafızı ile aranı iyi tut",
                ru: "Поддерживать хорошие отношения со Смотрителем"
            },
            type: 'wait',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Do not harm Zryachiy, his followers, or Lightkeeper-acquainted PMCs.",
                    tr: "Zryachiy'e, takipçilerine veya Işık Muhafızı'nın tanıdığı PMC'lere zarar verme.",
                    ru: "Не причиняйте вреда Зрячему, его последователям или знакомым Смотрителя ЧВК."
                },
                warning: {
                    en: "Harming any of these will decode your DSP transmitter and lock you out of Lightkeeper.",
                    tr: "Bunlardan herhangi birine zarar vermek DSP vericinizin kodunu bozar ve Işık Muhafızı'na erişimini engeller.",
                    ru: "Причинение вреда кому-либо из них приведет к раскодированию вашего передатчика DSP и заблокирует доступ к Смотрителю."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Maintain a good standing with Lightkeeper until he gets the Armored case back.",
                            tr: "Işık Muhafızı Zırhlı Çantayı (Armored case) geri alana kadar onunla olan iyi ilişkini sürdür.",
                            ru: "Поддерживайте хорошие отношения со Смотрителем, пока он не вернет Бронированный кейс."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_blue_folders',
            label: {
                en: "Obtain 3 TerraGroup Blue Folders materials",
                tr: "3 adet TerraGroup Mavi Klasör materyali edin",
                ru: "Получить 3 материала Синих папок TerraGroup"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Various", tr: "Çeşitli", ru: "Различное" },
                objective: {
                    en: "Find 3 TerraGroup Blue Folders materials in raid.",
                    tr: "Baskın (raid) içinde 3 adet TerraGroup Mavi Klasör (Blue Folders) malzemesi bul.",
                    ru: "Найдите 3 материала TerraGroup «Синие Папки» в рейде."
                },
                requiredItems: [
                    { en: "TerraGroup Blue Folders materials (x3)", tr: "TerraGroup Mavi Klasör malzemeleri (x3)", ru: "Материалы TerraGroup «Синие Папки» (x3)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Find 3 TerraGroup Blue Folders materials. They can spawn in various high-tier loot locations across Tarkov.",
                            tr: "3 adet TerraGroup Mavi Klasör malzemesi bul. Bunlar Tarkov'un çeşitli yüksek seviye ganimet noktalarında belirebilir.",
                            ru: "Найдите 3 материала TerraGroup «Синие Папки». Они могут появляться в различных местах с ценным лутом по всему Таркову."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_handover_folders',
            label: {
                en: "Bring Blue Folders to Lightkeeper",
                tr: "Mavi Klasörleri Işık Muhafızı'na götür",
                ru: "Принести Синие папки Смотрителю"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Hand over the 3 TerraGroup Blue Folders materials to Lightkeeper.",
                    tr: "3 adet TerraGroup Mavi Klasör malzemesini Işık Muhafızı'na teslim et.",
                    ru: "Передайте 3 материала TerraGroup «Синие Папки» Смотрителю."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Visit Lightkeeper with the Blue Folders in your inventory and hand them over.",
                            tr: "Mavi Klasörleri envanterinde taşıyarak Işık Muhafızı'nı ziyaret et ve onları teslim et.",
                            ru: "Посетите Смотрителя с Синими Папками в инвентаре и передайте их."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_yellow_flare',
            label: {
                en: "Launch yellow signal flare at ULTRA entrance",
                tr: "ULTRA girişinde sarı sinyal fişeği at",
                ru: "Запустить жёлтую сигнальную ракету у входа в Ультра"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Interchange", tr: "Değişim", ru: "Развязка" },
                objective: {
                    en: "Fire a yellow flare in front of the ULTRA Mall main entrance on Interchange.",
                    tr: "Değişim (Interchange) haritasında ULTRA Alışveriş Merkezi'nin ana girişinin önünde sarı bir işaret fişeği at.",
                    ru: "Выстрелите желтым сигнальным патроном перед главным входом в ТЦ Ультра на Развязке."
                },
                requiredItems: [
                    { en: "RSP-30 reactive signal cartridge (Yellow) OR ZiD SP-81 signal pistol + 26x75mm flare cartridge (Yellow)", tr: "RSP-30 reaktif sinyal fişeği (Sarı) VEYA ZiD SP-81 sinyal tabancası + 26x75mm fişek (Sarı)", ru: "РСП-30 реактивный сигнальный патрон (Желтый) ИЛИ сигнальный пистолет ЗиД СП-81 + сигнальный патрон 26x75мм (Желтый)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Interchange. Stand in front of the ULTRA Mall main entrance and fire a yellow flare.",
                            tr: "Değişim (Interchange) haritasına git. ULTRA Alışveriş Merkezi ana girişinin önünde dur ve sarı bir işaret fişeği ateşle.",
                            ru: "Отправляйтесь на Развязку. Встаньте перед главным входом в ТЦ Ультра и выстрелите желтым сигнальным патроном."
                        },
                        images: ['/Story/Ticket/Flare-Location.webp']
                    }
                ]
            }
        },
        {
            id: 'step_eliminate_15',
            label: {
                en: "Eliminate 15 targets on Interchange in one raid",
                tr: "Tek bir baskında Değişim'de 15 hedefi etkisiz hale getir",
                ru: "Уничтожить 15 целей на Развязке за один рейд"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Interchange", tr: "Değişim", ru: "Развязка" },
                objective: {
                    en: "Get 15 kills on Interchange in a single raid.",
                    tr: "Tek bir baskında Değişim (Interchange) haritasında 15 düşman öldür.",
                    ru: "Совершите 15 убийств на Развязке в одном рейде."
                },
                warning: {
                    en: "If you extract without 15 kills, both this and the flare objective must be redone. You can transit to other maps but kills must be on Interchange.",
                    tr: "Eğer 15 öldürmeye ulaşmadan çıkış yaparsan, hem bu görev hem de işaret fişeği görevi sıfırlanır ve baştan yapılmalıdır. Başka haritalara geçiş (transit) yapabilirsin ancak öldürmeler mutlaka Değişim (Interchange) haritasında yapılmalıdır.",
                    ru: "Если вы эвакуируетесь без 15 убийств, обе эти задачи (включая сигнальную ракету) придется выполнять заново. Можно переходить на другие карты, но убийства должны быть именно на Развязке."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Eliminate any 15 targets (PMCs or Scavs) on Interchange in one raid. Extract after completing.",
                            tr: "Tek bir baskında Değişim (Interchange) haritasında herhangi 15 hedefi (PMC veya Scav) ortadan kaldır. Tamamladıktan sonra haritadan çıkış yap.",
                            ru: "Уничтожьте любые 15 целей (ЧВК или Дикие) на Развязке в одном рейде. Эвакуируйтесь после выполнения."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_talk_lightkeeper_2',
            label: {
                en: "Talk to Lightkeeper about the mission",
                tr: "Görev hakkında Işık Muhafızı ile konuş",
                ru: "Поговорить со Смотрителем о миссии"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Return to Lightkeeper after completing the flare and elimination objectives.",
                    tr: "İşaret fişeği ve ortadan kaldırma hedeflerini tamamladıktan sonra Işık Muhafızı'na geri dön.",
                    ru: "Вернитесь к Смотрителю после выполнения задач с сигнальной ракетой и устранениями."
                },
                warning: {
                    en: "You need an empty special slot to accept the reward (Armored case).",
                    tr: "Ödülü (Zırhlı Çanta) kabul edebilmek için envanterinde boş bir özel yuvaya (special slot) ihtiyacın var.",
                    ru: "Вам понадобится пустой спецслот, чтобы принять награду (Бронированный кейс)."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Visit Lightkeeper. He will give you the Armored case as a reward.",
                            tr: "Işık Muhafızı'nı ziyaret et. Sana ödül olarak Zırhlı Çantayı verecek.",
                            ru: "Посетите Смотрителя. Он выдаст вам Бронированный кейс в качестве награды."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_ask_mechanic',
            label: {
                en: "Ask Mechanic for help",
                tr: "Mekanik'ten yardım iste",
                ru: "Попросить Механика о помощи"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Mechanic to ask for help unlocking the Armored case.",
                    tr: "Zırhlı Çantanın kilidini açmak konusunda yardım istemek için Mekanik'i ziyaret et.",
                    ru: "Посетите Механика, чтобы попросить помощи в разблокировке Бронированного кейса."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open Traders menu. Select Mechanic. Ask him about unlocking the Armored case.",
                            tr: "Satıcılar menüsünü aç. Mekanik'i seç. Zırhlı Çantanın kilidini açma hakkında ona sor.",
                            ru: "Откройте меню торговцев. Выберите Механика. Спросите его о вскрытии Бронированного кейса."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_signal_jammer',
            label: {
                en: "Obtain the experimental signal jammer",
                tr: "Deneysel sinyal bozucuyu edin",
                ru: "Получить экспериментальную глушилку сигнала"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Lab", tr: "Laboratuvar", ru: "Лаборатория" },
                objective: {
                    en: "Find the experimental signal jammer in The Lab.",
                    tr: "Laboratuvar'da (The Lab) deneysel sinyal karıştırıcıyı bul.",
                    ru: "Найдите экспериментальный глушитель сигналов в Лаборатории."
                },
                requiredItems: [
                    { en: "Experimental signal jammer", tr: "Deneysel sinyal karıştırıcı", ru: "Экспериментальный глушитель сигналов" }
                ]
            },
            subTasks: [
                {
                    id: 'step_jammer_loc1',
                    label: {
                        en: "Location 1: Glass Laboratory",
                        tr: "Konum 1: Cam Laboratuvar",
                        ru: "Место 1: Стеклянная лаборатория"
                    },
                    type: 'objective',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "Location 1: Left side glass laboratory inside the containment block, on the middle desks.",
                                    tr: "Konum 1: Karantina bloğunun (containment block) içindeki sol tarafta yer alan cam laboratuvar, orta masaların üzerinde.",
                                    ru: "Место 1: Стеклянная лаборатория с левой стороны внутри блока сдерживания, на средних столах."
                                },
                                images: ['/Story/Ticket/Jammer-Location1.webp']
                            }
                        ]
                    }
                },
                {
                    id: 'step_jammer_loc2',
                    label: {
                        en: "Location 2: Recreational Area",
                        tr: "Konum 2: Rekreasyon Alanı",
                        ru: "Место 2: Зона отдыха"
                    },
                    type: 'objective',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "Location 2: Recreational area (R21), on the round table in the 'Cat' room near the red keycard room.",
                                    tr: "Konum 2: Dinlenme alanı (R21), kırmızı anahtar kartı odasının yanındaki 'Kedi' (Cat) odasında bulunan yuvarlak masanın üzerinde.",
                                    ru: "Место 2: Зона отдыха (R21), на круглом столе в комнате «Кот» рядом с помещением красной ключ-карты."
                                },
                                images: ['/Story/Ticket/Jammer-Location2.webp']
                            }
                        ]
                    }
                },
                {
                    id: 'step_jammer_loc3',
                    label: {
                        en: "Location 3: Lecture Hall",
                        tr: "Konum 3: Konferans Salonu",
                        ru: "Место 3: Лекционный зал"
                    },
                    type: 'objective',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "Location 3: Lecture hall (R16), on a desk in the conference room downstairs from the kitchen area.",
                                    tr: "Konum 3: Konferans salonu (R16), mutfak alanının alt katında kalan konferans odasındaki bir masanın üzerinde.",
                                    ru: "Место 3: Лекционный зал (R16), на столе в конференц-зале на этаж ниже кухонной зоны."
                                },
                                images: ['/Story/Ticket/Jammer-Location3.webp']
                            }
                        ]
                    }
                }
            ]
        },
        {
            id: 'step_unlock_case',
            label: {
                en: "Unlock the Armored case",
                tr: "Zırhlı Çantanın kilidini aç",
                ru: "Открыть Бронированный кейс"
            },
            type: 'craft',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Craft the unlocked Armored case at Workbench level 1 using the signal jammer.",
                    tr: "Sinyal karıştırıcıyı kullanarak Sığınaktaki Çalışma Tezgahı'nda (Seviye 1) kilidi açılmış Zırhlı Çantayı üret.",
                    ru: "Создайте разблокированный Бронированный кейс на Верстаке 1 уровня с использованием глушителя сигналов."
                },
                warning: {
                    en: "The craft takes approximately 55 hours. Electricity must be on during the entire process.",
                    tr: "Bu üretim işlemi yaklaşık 55 saat sürer. Süreç boyunca sığınağın elektriği açık olmalıdır.",
                    ru: "Крафт занимает примерно 55 часов. Электричество должно быть включено на протяжении всего процесса."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to the Hideout Workbench level 1. Start the Armored case unlock craft recipe.",
                            tr: "Sığınaktaki Çalışma Tezgahı seviye 1'e git. Zırhlı Çanta kilidini açma tarifini başlat.",
                            ru: "Зайдите в Убежище на Верстак 1 уровня. Запустите рецепт разблокировки Бронированного кейса."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_obtain_ticket',
            label: {
                en: "Obtain the Ticket",
                tr: "Bileti al",
                ru: "Получить Билет"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Unpack the unlocked Armored case to receive Kruglov's RFID keycard.",
                    tr: "Kruglov'un RFID anahtar kartını almak için kilidi açılmış Zırhlı Çantanın paketini aç.",
                    ru: "Распакуйте разблокированный Бронированный кейс, чтобы получить RFID ключ-карту Круглова."
                },
                requiredItems: [
                    { en: "Kruglov's RFID keycard", tr: "Kruglov'un RFID anahtar kartı", ru: "RFID ключ-карта Круглова" },
                    { en: "RFID card manual (Handbook item)", tr: "RFID kart kılavuzu (El Kitabı eşyası)", ru: "Инструкция по RFID карте (предмет Справочника)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Right-click the unlocked Armored case and select 'unpack' to receive the keycard and manual.",
                            tr: "Kilidi açılmış Zırhlı Çantaya sağ tıkla ve anahtar kartı ile kılavuzu almak için 'paketi aç' (unpack) seçeneğini seç.",
                            ru: "Щелкните правой кнопкой мыши по разблокированному Бронированному кейсу и выберите «распаковать», чтобы получить ключ-карту и инструкцию."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_read_manual',
            label: {
                en: "Read the instructions from the armored case",
                tr: "Zırhlı çantadaki talimatları oku",
                ru: "Прочитать инструкции из бронированного кейса"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Menu / Handbook", tr: "Menü / El Kitabı", ru: "Меню / Справочник" },
                objective: {
                    en: "Read the RFID card manual in your Handbook.",
                    tr: "El Kitabındaki (Handbook) RFID kart kılavuzunu oku.",
                    ru: "Прочитайте инструкцию по RFID карте в вашем Справочнике."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open your Handbook. Find and read the 'RFID card manual' note.",
                            tr: "El Kitabını aç. 'RFID kart kılavuzu' notunu bul ve oku.",
                            ru: "Откройте Справочник. Найдите и прочитайте записку «Инструкция по RFID карте»."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_contact_kerman_choice',
            label: {
                en: "Contact Mr. Kerman - CHOICE POINT",
                tr: "Bay Kerman ile iletişime geç - SEÇİM NOKTASI",
                ru: "Связаться с Керманом — ТОЧКА ВЫБОРА"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Hideout / Intelligence Center", tr: "Sığınak / İstihbarat Merkezi", ru: "Убежище / Разведцентр" },
                objective: {
                    en: "Make a critical choice: Accept or refuse Mr. Kerman's offer.",
                    tr: "Kritik bir seçim yap: Bay Kerman'ın teklifini kabul et veya reddet.",
                    ru: "Сделайте критический выбор: Примите или отклоните предложение господина Кермана."
                },
                warning: {
                    en: "THIS IS A POINT OF NO RETURN! Your choice determines which ending you get.",
                    tr: "BU DÖNÜLMEZ BİR NOKTADIR! Seçimin, hikayede hangi sona ulaşacağını belirler.",
                    ru: "ЭТО ТОЧКА НЕВОЗВРАТА! Ваш выбор определит, какую концовку вы получите."
                },
                story: {
                    en: "Mr. Kerman offers to help activate the keycard. Accepting leads to Savior/Survivor endings. Refusing leads to Debtor/Fallen endings.",
                    tr: "Bay Kerman anahtar kartını etkinleştirmek için yardım etmeyi teklif ediyor. Bunu kabul etmek Kurtarıcı (Savior) veya Hayatta Kalan (Survivor) sonlarına yol açar. Reddetmek ise Borçlu (Debtor) veya Düşmüş (Fallen) sonlarına yol açar.",
                    ru: "Господин Керман предлагает помочь активировать ключ-карту. Согласие ведет к концовкам «Спаситель» / «Выживший». Отказ ведет к концовкам «Должник» / «Павший»."
                }
            },
            subTasks: [
                {
                    id: 'choice_accept_kerman',
                    label: {
                        en: "Option A: Accept Mr. Kerman's Help",
                        tr: "Seçenek A: Bay Kerman'ın yardımını kabul et",
                        ru: "Вариант А: Принять помощь Кермана"
                    },
                    type: 'talk',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "CHOICE A: Accept Mr. Kerman's help -> Progress toward the Savior or Survivor ending.",
                                    tr: "SEÇENEK A: Bay Kerman'ın yardımını kabul et -> Kurtarıcı veya Hayatta Kalan sonuna doğru ilerle.",
                                    ru: "ВЫБОР А: Примите помощь господина Кермана -> Продвигайтесь к концовке «Спаситель» или «Выживший»."
                                }
                            }
                        ]
                    }
                },
                {
                    id: 'choice_refuse_kerman',
                    label: {
                        en: "Option B: Refuse Mr. Kerman's Help",
                        tr: "Seçenek B: Bay Kerman'ın yardımını reddet",
                        ru: "Вариант Б: Отказаться от помощи Кермана"
                    },
                    type: 'talk',
                    isSubTask: true,
                    details: {
                        guideSteps: [
                            {
                                text: {
                                    en: "CHOICE B: Refuse Mr. Kerman's help -> Pay Prapor 500M Roubles (300M if you gave him the case in Falling Skies).",
                                    tr: "SEÇENEK B: Bay Kerman'ın yardımını reddet -> Prapor'a 500 Milyon Ruble öde ('Falling Skies' görevinde çantayı ona verdiysen 300 Milyon).",
                                    ru: "ВЫБОР Б: Отклоните помощь господина Кермана -> Заплатите Прапору 500 млн рублей (300 млн, если вы отдали ему кейс в «Падающих небесах»)."
                                }
                            }
                        ]
                    }
                }
            ]
        }
    ]
};